module.exports = __webpack_public_path__ + "static/media/physiotherapy-cover.f8fa7029.png";